import routerOptions0 from "/var/lib/jenkins/workspace/Vapor/agents_deploy_prod/agents/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}